/**
 * Generates and retrieves a unique session-based user token for Algolia.
 * @returns {string} The user token.
 */
export const getSessionUserToken = () => {
  const tokenKey = 'algoliaUserToken';
  let userToken = sessionStorage.getItem(tokenKey);
  if (!userToken) {
    userToken = `dealmed-app-${Date.now()}`;
    sessionStorage.setItem(tokenKey, userToken);
  }
  return userToken;
}; 